/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24 3c0 1.6569-1.3431 3-3 3a2.9863 2.9863 0 0 1-1.524-.4154l-6.028 6.028A3.4834 3.4834 0 0 1 14 13.5c0 1.933-1.567 3.5-3.5 3.5S7 15.433 7 13.5 8.567 10 10.5 10c.6951 0 1.3428.2026 1.8874.552l6.028-6.028A2.9853 2.9853 0 0 1 18 3c0-1.6568 1.3431-3 3-3s3 1.3432 3 3Zm-1.5 0c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5.6716-1.5 1.5-1.5 1.5.6716 1.5 1.5Zm-10 10.5c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M1.5 13.75C1.5 8.9175 5.4175 5 10.25 5c.882 0 1.7322.1303 2.5332.3721a.75.75 0 1 0 .4336-1.436A10.2505 10.2505 0 0 0 10.25 3.5C4.589 3.5 0 8.089 0 13.75 0 19.4109 4.589 24 10.25 24c5.6609 0 10.25-4.5891 10.25-10.25 0-1.0305-.1523-2.0267-.4361-2.9668a.75.75 0 0 0-1.436.4336A8.7513 8.7513 0 0 1 19 13.75c0 4.8325-3.9175 8.75-8.75 8.75S1.5 18.5825 1.5 13.75Z"
    />
  </React.Fragment>,
  'MenuOpenAPIConsole'
);
